import { UI } from 'common';
import React from 'react';

const { WrappedButton, WrappedButtonType } = UI;

const ParcelGuardCoveragePanel = ({
	printDetails: { insuredValue },
	onCheckClaimStatusClick,
}) => (
	<div className="parcelguard-coverage-panel">
		<div className="p-col-12">
			<p>
				If you have already filed an insurance claim, you can check the status
				of your claim with your claim number from your confirmation email.
			</p>
		</div>
		<div className="parcelguard-coverage-claim p-col-12">
			<div className="parcelguard-coverage-price">
				Max Claim Amount: ${insuredValue}
			</div>
			<div>
				<WrappedButton
					label="Check Claim Status"
					className="parcelguard-detail-menu-icon"
					dataqa="parcelguard-file-claim-btn"
					buttonType={WrappedButtonType.TertiaryGrey}
					icon={null}
					onClick={onCheckClaimStatusClick}
				/>
			</div>
		</div>
	</div>
);

export default ParcelGuardCoveragePanel;
